import { FC } from "react";

export const Phone = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 1H8C6.34 1 5 2.34 5 4V20C5 21.66 6.34 23 8 23H16C17.66 23 19 21.66 19 20V4C19 2.34 17.66 1 16 1ZM13.5 21H10.5C10.22 21 10 20.78 10 20.5C10 20.22 10.22 20 10.5 20H13.5C13.78 20 14 20.22 14 20.5C14 20.78 13.78 21 13.5 21ZM17 18H7V4H17V18Z"
      fill="#6F7F9E"
    />
  </svg>
);

export const Mail = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19 18H5C4.45 18 4 17.55 4 17V8L10.94 12.34C11.59 12.75 12.41 12.75 13.06 12.34L20 8V17C20 17.55 19.55 18 19 18ZM12 11L4 6H20L12 11Z"
      fill="#6F7F9E"
    />
  </svg>
);

export const Download = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
      stroke="#032565"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.33301L10.0007 12.4997L14.1673 8.33301"
      stroke="#032565"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5V2.5"
      stroke="#032565"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Placeholder = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 15L16 10L5 21"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewEye = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.833496 9.9987C0.833496 9.9987 4.16683 3.33203 10.0002 3.33203C15.8335 3.33203 19.1668 9.9987 19.1668 9.9987C19.1668 9.9987 15.8335 16.6654 10.0002 16.6654C4.16683 16.6654 0.833496 9.9987 0.833496 9.9987Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Trash = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 5H4.16667H17.5"
      stroke="#F23D35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6665 5.0013V3.33464C6.6665 2.89261 6.8421 2.46868 7.15466 2.15612C7.46722 1.84356 7.89114 1.66797 8.33317 1.66797H11.6665C12.1085 1.66797 12.5325 1.84356 12.845 2.15612C13.1576 2.46868 13.3332 2.89261 13.3332 3.33464V5.0013M15.8332 5.0013V16.668C15.8332 17.11 15.6576 17.5339 15.345 17.8465C15.0325 18.159 14.6085 18.3346 14.1665 18.3346H5.83317C5.39114 18.3346 4.96722 18.159 4.65466 17.8465C4.3421 17.5339 4.1665 17.11 4.1665 16.668V5.0013H15.8332Z"
      stroke="#F23D35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6665 9.16797V14.168"
      stroke="#F23D35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3335 9.16797V14.168"
      stroke="#F23D35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Pencil = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99136 14.9574C1.92934 14.8984 1.93525 14.7943 1.94877 14.7065C2.09559 13.7538 2.5404 12.0542 3.09534 11.2942C3.65028 10.5342 4.31558 9.87713 4.96964 9.21426C7.66905 6.47848 10.2384 3.57541 13.1902 1.15881C13.2781 1.08685 13.3726 1.01262 13.4827 1.0015C13.6928 0.980273 13.8545 1.18783 13.9752 1.37364C14.312 1.89195 15.4724 3.23379 15.8092 3.7521C15.87 3.84565 15.933 3.94561 15.9394 4.05946C15.9504 4.25528 15.7958 4.41069 15.6548 4.53543C13.0769 6.81562 10.5731 9.19231 8.14933 11.6597C7.4078 12.4146 6.6695 13.1817 5.8273 13.8031C4.98509 14.4245 3.20086 14.899 2.18304 14.9966C2.11632 15.003 2.0415 15.0051 1.99136 14.9574Z"
      stroke="#032565"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SaveIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8315 1.66797H4.99821C4.55618 1.66797 4.13226 1.84356 3.8197 2.15612C3.50714 2.46868 3.33154 2.89261 3.33154 3.33464V16.668C3.33154 17.11 3.50714 17.5339 3.8197 17.8465C4.13226 18.159 4.55618 18.3346 4.99821 18.3346H14.9982C15.4402 18.3346 15.8642 18.159 16.1767 17.8465C16.4893 17.5339 16.6649 17.11 16.6649 16.668V7.5013L10.8315 1.66797Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8315 1.66797V7.5013H16.6649"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownIcon = (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L6 6L11 1"
      stroke="#5E6E88"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Chat = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4395 8.08336C16.4423 9.18325 16.1853 10.2683 15.6895 11.25C15.1015 12.4265 14.1976 13.416 13.079 14.1078C11.9604 14.7995 10.6713 15.1662 9.35612 15.1667C8.25623 15.1696 7.17122 14.9126 6.18945 14.4167L1.43945 16L3.02279 11.25C2.5269 10.2683 2.26992 9.18325 2.27279 8.08336C2.2733 6.76815 2.63996 5.47907 3.33172 4.36048C4.02347 3.2419 5.013 2.338 6.18945 1.75002C7.17122 1.25413 8.25623 0.997156 9.35612 1.00002H9.77279C11.5097 1.09585 13.1503 1.82899 14.3804 3.05907C15.6105 4.28915 16.3436 5.92973 16.4395 7.66669V8.08336Z"
      stroke="#F6F8FD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9996 14.0001L11.0996 11.1001"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortDown = (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.1665H9.66667M1 3.83317H7M1 6.49984H7M10.3333 3.83317V11.8332M10.3333 11.8332L7.66667 9.1665M10.3333 11.8332L13 9.1665"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Bell: FC<{ className?: string }> = ({ className }) => (
  <svg
    width="20"
    height="20"
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8569 15.0817C14.7515 14.857 16.5784 14.4116 18.3112 13.7719C16.8744 12.177 15.9999 10.0656 15.9999 7.75V7.04919C16 7.03281 16.0001 7.01641 16.0001 7C16.0001 3.68629 13.3138 1 10.0001 1C6.68637 1 4.00007 3.68629 4.00007 7L3.99988 7.75C3.99988 10.0656 3.12535 12.177 1.68855 13.7719C3.42148 14.4116 5.24851 14.857 7.14321 15.0818M12.8569 15.0817C11.9201 15.1928 10.9666 15.25 9.99988 15.25C9.03324 15.25 8.07996 15.1929 7.14321 15.0818M12.8569 15.0817C12.9499 15.3711 13.0001 15.6797 13.0001 16C13.0001 17.6569 11.6569 19 10.0001 19C8.34322 19 7.00007 17.6569 7.00007 16C7.00007 15.6797 7.05026 15.3712 7.14321 15.0818M1.12451 5.5C1.41179 3.78764 2.18261 2.23924 3.29175 1M16.7084 1C17.8175 2.23924 18.5884 3.78764 18.8756 5.5"
      stroke="#032565"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
